import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { categories } from '@/mocks/categories';

export default function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 40);
    };
    handleScroll();
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    setMobileMenuOpen(false);
  }, [location.pathname]);

  const isActive = (path: string) => location.pathname === path;

  return (
    <>
      <nav
        className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
          isScrolled ? 'bg-background-50 shadow-sm' : 'bg-transparent'
        }`}
      >
        <div className="w-full px-4 md:px-6">
          <div className="flex items-center justify-between h-16">
            <Link
              to="/"
              className="flex items-center gap-2 whitespace-nowrap"
            >
              <span className="text-2xl font-heading text-primary-600 tracking-wide">
                178漫画网
              </span>
            </Link>

            <div className="hidden md:flex items-center gap-8">
              <Link
                to="/"
                className={`text-sm font-medium whitespace-nowrap transition-colors cursor-pointer ${
                  isActive('/') ? 'text-primary-600' : 'text-foreground-700 hover:text-primary-500'
                }`}
              >
                首页
              </Link>
              <Link
                to="/category/school-life"
                className={`text-sm font-medium whitespace-nowrap transition-colors cursor-pointer ${
                  location.pathname.startsWith('/category')
                    ? 'text-primary-600'
                    : 'text-foreground-700 hover:text-primary-500'
                }`}
              >
                分类浏览
              </Link>
              <Link
                to="/about"
                className={`text-sm font-medium whitespace-nowrap transition-colors cursor-pointer ${
                  isActive('/about') ? 'text-primary-600' : 'text-foreground-700 hover:text-primary-500'
                }`}
              >
                关于我们
              </Link>
            </div>

            <div className="hidden md:flex items-center gap-3">
              <Link
                to="/category/school-life"
                className="px-5 py-2 bg-primary-500 text-background-50 rounded-full text-sm font-medium whitespace-nowrap hover:bg-primary-600 transition-colors cursor-pointer"
              >
                开始阅读
              </Link>
            </div>

            <button
              className="md:hidden w-10 h-10 flex items-center justify-center text-foreground-700 cursor-pointer"
              onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
              aria-label="菜单"
            >
              <i className={`ri-${mobileMenuOpen ? 'close' : 'menu'}-line text-xl`}></i>
            </button>
          </div>
        </div>
      </nav>

      {mobileMenuOpen && (
        <div className="fixed inset-0 z-40 bg-background-50 pt-16 md:hidden">
          <div className="flex flex-col gap-4 px-6 py-8">
            <Link
              to="/"
              className="text-lg font-medium text-foreground-800 py-2 cursor-pointer"
              onClick={() => setMobileMenuOpen(false)}
            >
              首页
            </Link>
            <div className="border-t border-background-200">
              <p className="text-sm text-foreground-500 pt-4 pb-2">漫画分类</p>
              {categories.slice(0, 5).map((cat) => (
                <Link
                  key={cat.id}
                  to={`/category/${cat.slug}`}
                  className="block text-base text-foreground-700 py-2 cursor-pointer hover:text-primary-500 transition-colors"
                  onClick={() => setMobileMenuOpen(false)}
                >
                  {cat.name}
                </Link>
              ))}
            </div>
            <Link
              to="/about"
              className="text-lg font-medium text-foreground-800 py-2 cursor-pointer"
              onClick={() => setMobileMenuOpen(false)}
            >
              关于我们
            </Link>
            <Link
              to="/category/school-life"
              className="mt-4 px-5 py-3 bg-primary-500 text-background-50 rounded-full text-center font-medium whitespace-nowrap cursor-pointer"
              onClick={() => setMobileMenuOpen(false)}
            >
              开始阅读
            </Link>
          </div>
        </div>
      )}

      <div className="h-16"></div>
    </>
  );
}